var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 183,
  height: 96,
  viewBox: "0 0 183 96",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3.59 56.519v7.497c.69 3.43 2.338 6.448 4.944 9.053 3.536 3.536 7.803 5.304 12.802 5.304 4.998 0 9.265-1.768 12.802-5.304 3.535-3.535 5.304-7.803 5.304-12.802 0-4.998-1.77-9.265-5.304-12.801-3.537-3.536-7.804-5.304-12.802-5.304-4.998 0-9.266 1.768-12.802 5.304-2.606 2.606-4.254 5.623-4.945 9.053ZM1.794 41.883c.99 0 1.794.803 1.794 1.794v3.71a22.967 22.967 0 0 1 2.273-2.633c4.281-4.253 9.438-6.38 15.474-6.38 6.062 0 11.226 2.133 15.494 6.4 4.267 4.267 6.4 9.432 6.4 15.493 0 6.036-2.133 11.194-6.4 15.474-4.268 4.28-9.432 6.42-15.494 6.42-6.035 0-11.193-2.14-15.474-6.42a22.899 22.899 0 0 1-2.273-2.632v21.097a1.794 1.794 0 1 1-3.589 0V43.676c0-.991.804-1.794 1.795-1.794Z",
  fill: "url(#a)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M83.55 45.75c-3.111-2.392-6.728-3.588-10.848-3.588-4.972 0-9.226 1.761-12.762 5.284-3.536 3.523-5.304 7.783-5.304 12.781 0 4.122 1.196 7.737 3.59 10.848l25.323-25.324ZM60.657 73.708c3.4 3.107 7.45 4.65 12.148 4.626a18.064 18.064 0 0 0 13.14-5.76 1.926 1.926 0 0 1 2.052-.503c1.289.46 1.707 2.098.772 3.098-.18.192-.366.384-.555.573-4.28 4.28-9.451 6.42-15.513 6.42-6.036 0-11.193-2.14-15.474-6.42-4.28-4.28-6.42-9.451-6.42-15.514 0-6.034 2.14-11.192 6.42-15.473 4.28-4.28 9.438-6.42 15.474-6.42 5.184 0 9.717 1.554 13.599 4.665a28.639 28.639 0 0 1 1.914 1.755c.24.24.465.479.678.718l-2.712 2.712-25.523 25.523Z",
  fill: "url(#b)"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M138.823 63.817v-7.099c-.665-3.51-2.327-6.593-4.985-9.252-3.536-3.536-7.803-5.304-12.801-5.304-4.999 0-9.266 1.768-12.802 5.304-3.536 3.536-5.304 7.803-5.304 12.802 0 4.998 1.768 9.258 5.304 12.781 3.536 3.523 7.803 5.284 12.802 5.284 4.998 0 9.265-1.768 12.801-5.304 2.658-2.658 4.32-5.73 4.985-9.212Zm1.795 17.228a1.795 1.795 0 0 1-1.795-1.795v-6.18c-.691.93-1.449 1.82-2.273 2.67-4.281 4.282-9.452 6.422-15.513 6.422-6.036 0-11.194-2.14-15.474-6.421-4.281-4.28-6.42-9.438-6.42-15.473 0-6.063 2.139-11.233 6.42-15.514 4.28-4.28 9.438-6.42 15.474-6.42 6.061 0 11.232 2.14 15.513 6.42a26.89 26.89 0 0 1 2.273 2.672v-3.749a1.795 1.795 0 0 1 3.589 0V79.25c0 .992-.803 1.795-1.794 1.795Z",
  fill: "url(#c)"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M156.171 41.882c.991 0 1.794.804 1.794 1.795v5.344a23.065 23.065 0 0 1 2.593-3.07c2.419-2.42 4.885-3.96 7.397-4.623 1.182-.312 2.334.605 2.334 1.828v.112c0 .878-.615 1.61-1.464 1.834-1.803.472-3.654 1.66-5.555 3.56-3.403 3.377-5.172 7.432-5.305 12.164V79.25a1.794 1.794 0 1 1-3.589 0V43.677c0-.99.804-1.795 1.795-1.795Z",
  fill: "url(#d)"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M182.652 19.031v60.22a1.795 1.795 0 0 1-3.59 0V19.03a1.795 1.795 0 0 1 3.59 0Z",
  fill: "url(#e)"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M10.949 92.292c.22-.18.332-.44.332-.777s-.111-.597-.332-.777c-.222-.182-.546-.272-.974-.272H8.828v2.098h1.147c.428 0 .752-.09.974-.272Zm.268-2.43c.34.15.6.368.78.65.182.28.273.615.273 1.003 0 .382-.091.716-.272 1a1.73 1.73 0 0 1-.781.653c-.34.15-.74.226-1.197.226H8.828v1.525h-.982v-5.284h2.174c.458 0 .857.076 1.197.227Z",
  fill: "url(#f)"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M17.213 94.096v.823H13.25v-5.284h3.857v.823h-2.875v1.374h2.55v.808h-2.55v1.456h2.981Z",
  fill: "url(#g)"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M20.572 94.089a2.25 2.25 0 0 0 1.023-.223c.294-.148.52-.36.679-.634a1.87 1.87 0 0 0 .238-.954c0-.363-.08-.681-.238-.955a1.592 1.592 0 0 0-.68-.634 2.24 2.24 0 0 0-1.022-.223H19.29v3.623h1.283Zm-2.265-4.454h2.31c.564 0 1.065.11 1.502.329a2.43 2.43 0 0 1 1.02.928c.24.4.362.862.362 1.386 0 .523-.121.984-.363 1.384-.241.4-.58.71-1.019.929-.437.219-.938.328-1.502.328h-2.31v-5.284Z",
  fill: "url(#h)"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  d: "M24.542 89.635h.981v5.284h-.981v-5.284Z",
  fill: "url(#i)"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  d: "m30.052 92.926-.996-2.31-.989 2.31h1.985Zm.325.77h-2.642l-.52 1.223h-1.013l2.378-5.284h.966l2.386 5.284h-1.027l-.528-1.223Z",
  fill: "url(#j)"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  d: "M33.41 90.466h-1.75v-.83h4.483v.83h-1.751v4.453h-.981v-4.453Z",
  fill: "url(#k)"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  d: "M39.985 90.738c-.222-.181-.546-.272-.974-.272h-1.147v2.106h1.147c.428 0 .752-.092.974-.276.221-.183.332-.444.332-.781s-.11-.596-.332-.777Zm.355 4.181-1.08-1.547a1.983 1.983 0 0 1-.204.008h-1.192v1.539h-.981v-5.284h2.173c.458 0 .857.076 1.197.227.34.15.6.368.781.65.181.28.272.615.272 1.003 0 .397-.097.74-.29 1.027-.195.286-.473.5-.835.641l1.215 1.736H40.34Z",
  fill: "url(#l)"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  d: "M42.4 89.635h.981v5.284H42.4v-5.284Z",
  fill: "url(#m)"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  d: "M45.808 94.644a2.587 2.587 0 0 1-1.011-.97 2.69 2.69 0 0 1-.367-1.396c0-.518.124-.984.37-1.397a2.616 2.616 0 0 1 1.015-.97c.431-.234.913-.35 1.446-.35.432 0 .828.074 1.185.225.357.151.66.37.906.657l-.634.597a1.85 1.85 0 0 0-1.412-.62c-.362 0-.687.08-.973.238-.287.159-.511.379-.672.66a1.895 1.895 0 0 0-.242.96c0 .357.08.676.242.958.16.282.385.502.672.66.286.159.611.238.973.238.559 0 1.03-.209 1.412-.627l.634.605a2.42 2.42 0 0 1-.91.656 3.05 3.05 0 0 1-1.189.227 2.975 2.975 0 0 1-1.445-.352Z",
  fill: "url(#n)"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  d: "M54.643 94.089c.387 0 .728-.075 1.022-.223.295-.148.52-.36.68-.634a1.87 1.87 0 0 0 .237-.954c0-.363-.079-.681-.238-.955a1.59 1.59 0 0 0-.679-.634 2.24 2.24 0 0 0-1.022-.223h-1.284v3.623h1.284Zm-2.265-4.454h2.31c.563 0 1.064.11 1.502.329.438.219.777.528 1.019.928.241.4.362.862.362 1.386 0 .523-.12.984-.362 1.384-.242.4-.581.71-1.02.929-.437.219-.938.328-1.501.328h-2.31v-5.284Z",
  fill: "url(#o)"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  d: "M62.575 94.096v.823h-3.962v-5.284h3.856v.823h-2.875v1.374h2.551v.808h-2.551v1.456h2.981Z",
  fill: "url(#p)"
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  d: "M68.365 89.635v5.284h-.808l-2.913-3.578v3.578h-.974v-5.284h.807l2.914 3.578v-3.578h.974Z",
  fill: "url(#q)"
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  d: "M70.855 90.466h-1.751v-.83h4.483v.83h-1.75v4.453h-.982v-4.453Z",
  fill: "url(#r)"
})), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
  d: "M74.327 89.635h.981v5.284h-.981v-5.284Z",
  fill: "url(#s)"
})), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
  d: "M77.191 94.82c-.38-.115-.68-.268-.902-.46l.34-.762c.216.171.481.31.796.419.315.108.63.163.948.163.392 0 .685-.064.879-.19.194-.125.29-.291.29-.498a.482.482 0 0 0-.162-.373 1.14 1.14 0 0 0-.411-.23 9.342 9.342 0 0 0-.68-.189 8.04 8.04 0 0 1-.977-.287 1.608 1.608 0 0 1-.641-.449c-.179-.204-.268-.48-.268-.827 0-.291.079-.556.238-.796.158-.239.397-.428.717-.57.32-.14.71-.21 1.173-.21.322 0 .64.04.951.12.312.08.581.196.808.347l-.31.762a3.045 3.045 0 0 0-.724-.31 2.717 2.717 0 0 0-.732-.105c-.388 0-.676.066-.864.197a.605.605 0 0 0-.284.52.47.47 0 0 0 .162.37c.109.096.246.171.412.227.166.055.392.118.68.188.392.091.714.185.965.283.252.099.467.248.646.45.178.2.268.472.268.814 0 .292-.08.557-.238.793-.159.237-.4.425-.72.566-.323.141-.715.212-1.178.212-.408 0-.802-.058-1.182-.174Z",
  fill: "url(#t)"
})), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
  d: "M82.479 90.466h-1.752v-.83h4.484v.83H83.46v4.453h-.981v-4.453Z",
  fill: "url(#u)"
})), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
  d: "M89.053 90.738c-.222-.181-.546-.272-.974-.272h-1.147v2.106h1.147c.428 0 .752-.092.974-.276.221-.183.332-.444.332-.781s-.11-.596-.332-.777Zm.355 4.181-1.08-1.547a1.989 1.989 0 0 1-.204.008h-1.192v1.539h-.982v-5.284h2.174c.458 0 .857.076 1.197.227.34.15.6.368.78.65.182.28.273.615.273 1.003 0 .397-.097.74-.29 1.027-.195.286-.473.5-.835.641l1.215 1.736h-1.056Z",
  fill: "url(#v)"
})), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
  d: "M93.672 93.055v1.864h-.981v-1.85l-2.076-3.434h1.049l1.547 2.575 1.563-2.575h.966l-2.068 3.42Z",
  fill: "url(#w)"
})), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
  d: "m101.567 92.926-.996-2.31-.99 2.31h1.986Zm.325.77H99.25l-.52 1.223h-1.013l2.378-5.284h.966l2.386 5.284h-1.027l-.528-1.223Z",
  fill: "url(#x)"
})), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
  d: "M108.813 89.635v5.284h-.808l-2.913-3.578v3.578h-.974v-5.284h.808l2.913 3.578v-3.578h.974Z",
  fill: "url(#y)"
})), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
  d: "M112.496 94.089c.388 0 .729-.075 1.023-.223a1.59 1.59 0 0 0 .679-.634c.159-.274.238-.592.238-.954 0-.363-.079-.681-.238-.955a1.585 1.585 0 0 0-.679-.634 2.239 2.239 0 0 0-1.023-.223h-1.283v3.623h1.283Zm-2.264-4.454h2.31c.563 0 1.064.11 1.501.329.438.219.778.528 1.02.928.241.4.362.862.362 1.386 0 .523-.121.984-.362 1.384-.242.4-.582.71-1.02.929-.437.219-.938.328-1.501.328h-2.31v-5.284Z",
  fill: "url(#z)"
})), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
  d: "M121.969 93.896c.281-.158.503-.38.664-.664.161-.284.242-.603.242-.955s-.081-.67-.242-.954a1.723 1.723 0 0 0-.664-.665 1.905 1.905 0 0 0-.951-.237c-.353 0-.67.079-.952.237a1.73 1.73 0 0 0-.664.665 1.902 1.902 0 0 0-.241.954c0 .352.08.67.241.955.162.284.383.506.664.664.282.159.599.238.952.238.352 0 .669-.08.951-.238Zm-2.408.748a2.6 2.6 0 0 1-1.019-.974 2.67 2.67 0 0 1-.37-1.393c0-.513.123-.977.37-1.393.247-.415.586-.739 1.019-.973.432-.234.918-.35 1.457-.35.538 0 1.023.116 1.456.35.433.234.773.558 1.019.97.247.412.37.878.37 1.396 0 .518-.123.984-.37 1.397a2.603 2.603 0 0 1-1.019.97c-.433.234-.918.35-1.456.35a3.012 3.012 0 0 1-1.457-.35Z",
  fill: "url(#A)"
})), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
  d: "M128.007 90.738c-.222-.181-.546-.272-.974-.272h-1.147v2.106h1.147c.428 0 .752-.092.974-.276.221-.183.332-.444.332-.781s-.111-.596-.332-.777Zm.354 4.181-1.079-1.547a1.987 1.987 0 0 1-.204.008h-1.192v1.539h-.981v-5.284h2.173c.458 0 .857.076 1.197.227.339.15.6.368.781.65.181.28.272.615.272 1.003 0 .397-.097.74-.291 1.027-.194.286-.472.5-.834.641l1.215 1.736h-1.057Z",
  fill: "url(#B)"
})), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
  d: "M131.418 90.466h-1.751v-.83h4.484v.83H132.4v4.453h-.982v-4.453Z",
  fill: "url(#C)"
})), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
  d: "M139.585 89.635v5.284h-.981v-2.264h-2.732v2.264h-.982v-5.284h.982v2.182h2.732v-2.182h.981Z",
  fill: "url(#D)"
})), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
  d: "M144.423 93.896c.282-.158.504-.38.665-.664.16-.284.241-.603.241-.955s-.081-.67-.241-.954a1.719 1.719 0 0 0-.665-.665 1.902 1.902 0 0 0-.951-.237c-.352 0-.669.079-.951.237-.281.159-.503.38-.664.665a1.903 1.903 0 0 0-.242.954c0 .352.081.67.242.955.161.284.383.506.664.664.282.159.599.238.951.238.353 0 .669-.08.951-.238Zm-2.408.748a2.598 2.598 0 0 1-1.018-.974 2.67 2.67 0 0 1-.37-1.393c0-.513.123-.977.37-1.393a2.6 2.6 0 0 1 1.018-.973c.433-.234.919-.35 1.457-.35.539 0 1.024.116 1.457.35a2.62 2.62 0 0 1 1.019.97c.247.412.37.878.37 1.396a2.617 2.617 0 0 1-1.389 2.367c-.433.234-.918.35-1.457.35a3.018 3.018 0 0 1-1.457-.35Z",
  fill: "url(#E)"
})), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
  d: "M149.624 94.089c.387 0 .728-.075 1.022-.223.295-.148.521-.36.68-.634.159-.274.237-.592.237-.954 0-.363-.078-.681-.237-.955a1.593 1.593 0 0 0-.68-.634 2.237 2.237 0 0 0-1.022-.223h-1.283v3.623h1.283Zm-2.265-4.454h2.31c.563 0 1.064.11 1.502.329.438.219.778.528 1.019.928.241.4.362.862.362 1.386 0 .523-.121.984-.362 1.384-.241.4-.581.71-1.019.929-.438.219-.939.328-1.502.328h-2.31v-5.284Z",
  fill: "url(#F)"
})), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
  d: "M157.013 93.896c.282-.158.503-.38.664-.664.161-.284.242-.603.242-.955s-.081-.67-.242-.954a1.716 1.716 0 0 0-.664-.665 1.905 1.905 0 0 0-.951-.237c-.352 0-.67.079-.951.237-.282.159-.503.38-.664.665a1.892 1.892 0 0 0-.242.954c0 .352.08.67.242.955.161.284.382.506.664.664.281.159.599.238.951.238s.669-.08.951-.238Zm-2.408.748a2.607 2.607 0 0 1-1.019-.974 2.679 2.679 0 0 1-.369-1.393c0-.513.123-.977.369-1.393.247-.415.587-.739 1.019-.973.433-.234.918-.35 1.457-.35.538 0 1.024.116 1.457.35.433.234.772.558 1.019.97.246.412.369.878.369 1.396a2.61 2.61 0 0 1-1.388 2.367c-.433.234-.919.35-1.457.35a3.015 3.015 0 0 1-1.457-.35Z",
  fill: "url(#G)"
})), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
  d: "M164.644 89.635v5.284h-.808l-2.913-3.578v3.578h-.974v-5.284h.808l2.913 3.578v-3.578h.974Z",
  fill: "url(#H)"
})), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
  d: "M167.135 90.466h-1.751v-.83h4.483v.83h-1.751v4.453h-.981v-4.453Z",
  fill: "url(#I)"
})), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
  d: "M170.607 89.635h.981v5.284h-.981v-5.284Z",
  fill: "url(#J)"
})), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
  d: "M174.014 94.644a2.586 2.586 0 0 1-1.011-.97 2.69 2.69 0 0 1-.366-1.396c0-.518.123-.984.37-1.397a2.609 2.609 0 0 1 1.015-.97c.43-.234.912-.35 1.445-.35.433 0 .828.074 1.185.225.357.151.659.37.906.657l-.634.597a1.848 1.848 0 0 0-1.411-.62c-.362 0-.687.08-.974.238a1.709 1.709 0 0 0-.672.66 1.899 1.899 0 0 0-.242.96c0 .357.081.676.242.958.161.282.385.502.672.66.287.159.612.238.974.238.558 0 1.029-.209 1.411-.627l.634.605a2.42 2.42 0 0 1-.91.656c-.359.151-.756.227-1.189.227a2.973 2.973 0 0 1-1.445-.352Z",
  fill: "url(#K)"
})), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
  d: "M178.928 94.82c-.38-.115-.681-.268-.902-.46l.34-.762c.216.171.481.31.796.419.314.108.63.163.947.163.392 0 .686-.064.879-.19.194-.125.291-.291.291-.498a.481.481 0 0 0-.162-.373 1.147 1.147 0 0 0-.412-.23 9.264 9.264 0 0 0-.679-.189 8.041 8.041 0 0 1-.978-.287 1.61 1.61 0 0 1-.641-.449c-.179-.204-.268-.48-.268-.827 0-.291.079-.556.238-.796.158-.239.397-.428.717-.57.319-.14.71-.21 1.174-.21.322 0 .639.04.95.12.313.08.582.196.808.347l-.309.762a3.055 3.055 0 0 0-.725-.31 2.718 2.718 0 0 0-.732-.105c-.387 0-.676.066-.864.197a.604.604 0 0 0-.283.52.47.47 0 0 0 .162.37c.108.096.245.171.412.227.165.055.392.118.678.188.393.091.715.185.967.283.251.099.466.248.645.45.179.2.268.472.268.814 0 .292-.079.557-.238.793-.158.237-.399.425-.72.566-.323.141-.715.212-1.178.212-.408 0-.802-.058-1.181-.174Z",
  fill: "url(#L)"
})), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
  d: "M121.823 8.436c-.986 0-1.785-.8-1.785-1.785V1.785a1.785 1.785 0 0 1 3.57 0V6.65c0 .986-.8 1.785-1.785 1.785Z",
  fill: "url(#M)"
})), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
  d: "M121.823 32.767a1.785 1.785 0 0 1-1.785-1.785V15.41a1.785 1.785 0 0 1 3.57 0v15.572c0 .986-.8 1.785-1.785 1.785Z",
  fill: "url(#N)"
})), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
  d: "M99.979 11.66c-.692 0-1.35-.406-1.641-1.082l-1.92-4.472a1.786 1.786 0 0 1 3.28-1.408l1.92 4.471a1.785 1.785 0 0 1-1.64 2.49Z",
  fill: "url(#O)"
})), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
  d: "M100.957 40.007c-.461 0-.922-.178-1.271-.533l-6.816-6.92a1.784 1.784 0 1 1 2.543-2.505l6.815 6.92a1.784 1.784 0 0 1-1.271 3.038Z",
  fill: "url(#P)"
})), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
  d: "M144.565 40.007a1.784 1.784 0 0 1-1.272-3.038l6.816-6.92a1.785 1.785 0 1 1 2.543 2.505l-6.816 6.92c-.349.355-.81.533-1.271.533Z",
  fill: "url(#Q)"
})), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
  d: "M109.578 34.017a1.784 1.784 0 0 1-1.641-1.082l-6.143-14.309a1.785 1.785 0 1 1 3.28-1.408l6.143 14.309a1.785 1.785 0 0 1-1.639 2.49Z",
  fill: "url(#R)"
})), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
  d: "M144.64 11.66A1.785 1.785 0 0 1 143 9.17l1.92-4.472a1.785 1.785 0 0 1 3.281 1.408l-1.921 4.472a1.784 1.784 0 0 1-1.64 1.081Z",
  fill: "url(#S)"
})), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
  d: "M135.041 34.017a1.785 1.785 0 0 1-1.64-2.49l6.143-14.309a1.786 1.786 0 0 1 3.281 1.408l-6.144 14.31a1.784 1.784 0 0 1-1.64 1.08Z",
  fill: "url(#T)"
})), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
  d: "M133.648 63.141a1.785 1.785 0 0 1-1.785-1.785c0-6.397-5.205-11.602-11.602-11.602a1.785 1.785 0 0 1 0-3.57c8.365 0 15.172 6.806 15.172 15.172 0 .986-.8 1.785-1.785 1.785Z",
  fill: "url(#U)"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: 43.23,
  y1: 96,
  x2: -12.271,
  y2: 54.974,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#AC9470"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.786,
  stopColor: "#CBB898"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "b",
  x1: 89.277,
  y1: 82.161,
  x2: 45.584,
  y2: 44.373,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#AC9470"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.786,
  stopColor: "#CBB898"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "c",
  x1: 142.412,
  y1: 82.162,
  x2: 98.275,
  y2: 39.225,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#AC9470"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.786,
  stopColor: "#CBB898"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "d",
  x1: 170.289,
  y1: 81.045,
  x2: 142.945,
  y2: 70.267,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#AC9470"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.786,
  stopColor: "#CBB898"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "e",
  x1: 182.652,
  y1: 81.045,
  x2: 175.547,
  y2: 80.651,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#AC9470"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.786,
  stopColor: "#CBB898"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "f",
  x1: 12.27,
  y1: 94.919,
  x2: 7.044,
  y2: 90.608,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#AC9470"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.786,
  stopColor: "#CBB898"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "g",
  x1: 17.213,
  y1: 94.919,
  x2: 12.125,
  y2: 91.159,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#AC9470"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.786,
  stopColor: "#CBB898"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "h",
  x1: 23.501,
  y1: 94.919,
  x2: 18.18,
  y2: 89.766,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#AC9470"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.786,
  stopColor: "#CBB898"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "i",
  x1: 25.523,
  y1: 94.919,
  x2: 23.638,
  y2: 94.574,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#AC9470"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.786,
  stopColor: "#CBB898"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "j",
  x1: 31.931,
  y1: 94.919,
  x2: 26.62,
  y2: 89.244,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#AC9470"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.786,
  stopColor: "#CBB898"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "k",
  x1: 36.143,
  y1: 94.919,
  x2: 30.904,
  y2: 90.539,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#AC9470"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.786,
  stopColor: "#CBB898"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "l",
  x1: 41.396,
  y1: 94.919,
  x2: 36.151,
  y2: 90.504,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#AC9470"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.786,
  stopColor: "#CBB898"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "m",
  x1: 43.381,
  y1: 94.919,
  x2: 41.496,
  y2: 94.574,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#AC9470"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.786,
  stopColor: "#CBB898"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "n",
  x1: 49.352,
  y1: 94.995,
  x2: 43.912,
  y2: 90.14,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#AC9470"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.786,
  stopColor: "#CBB898"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "o",
  x1: 57.571,
  y1: 94.919,
  x2: 52.251,
  y2: 89.767,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#AC9470"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.786,
  stopColor: "#CBB898"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "p",
  x1: 62.575,
  y1: 94.919,
  x2: 57.487,
  y2: 91.159,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#AC9470"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.786,
  stopColor: "#CBB898"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "q",
  x1: 68.365,
  y1: 94.919,
  x2: 63.088,
  y2: 90.3,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#AC9470"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.786,
  stopColor: "#CBB898"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "r",
  x1: 73.587,
  y1: 94.919,
  x2: 68.349,
  y2: 90.539,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#AC9470"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.786,
  stopColor: "#CBB898"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "s",
  x1: 75.308,
  y1: 94.919,
  x2: 73.423,
  y2: 94.574,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#AC9470"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.786,
  stopColor: "#CBB898"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "t",
  x1: 80.509,
  y1: 94.995,
  x2: 75.225,
  y2: 90.952,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#AC9470"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.786,
  stopColor: "#CBB898"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "u",
  x1: 85.211,
  y1: 94.919,
  x2: 79.972,
  y2: 90.539,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#AC9470"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.786,
  stopColor: "#CBB898"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "v",
  x1: 90.464,
  y1: 94.919,
  x2: 85.219,
  y2: 90.504,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#AC9470"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.786,
  stopColor: "#CBB898"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "w",
  x1: 95.74,
  y1: 94.919,
  x2: 90.422,
  y2: 89.837,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#AC9470"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.786,
  stopColor: "#CBB898"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "x",
  x1: 103.447,
  y1: 94.919,
  x2: 98.135,
  y2: 89.244,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#AC9470"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.786,
  stopColor: "#CBB898"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "y",
  x1: 108.813,
  y1: 94.919,
  x2: 103.536,
  y2: 90.299,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#AC9470"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.786,
  stopColor: "#CBB898"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "z",
  x1: 115.425,
  y1: 94.919,
  x2: 110.104,
  y2: 89.767,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#AC9470"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.786,
  stopColor: "#CBB898"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "A",
  x1: 123.863,
  y1: 94.995,
  x2: 118.391,
  y2: 89.348,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#AC9470"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.786,
  stopColor: "#CBB898"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "B",
  x1: 129.418,
  y1: 94.919,
  x2: 124.173,
  y2: 90.505,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#AC9470"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.786,
  stopColor: "#CBB898"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "C",
  x1: 134.151,
  y1: 94.919,
  x2: 128.912,
  y2: 90.539,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#AC9470"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.786,
  stopColor: "#CBB898"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "D",
  x1: 139.585,
  y1: 94.919,
  x2: 134.308,
  y2: 90.3,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#AC9470"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.786,
  stopColor: "#CBB898"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "E",
  x1: 146.318,
  y1: 94.995,
  x2: 140.846,
  y2: 89.348,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#AC9470"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.786,
  stopColor: "#CBB898"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "F",
  x1: 152.552,
  y1: 94.919,
  x2: 147.232,
  y2: 89.766,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#AC9470"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.786,
  stopColor: "#CBB898"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "G",
  x1: 158.907,
  y1: 94.995,
  x2: 153.435,
  y2: 89.348,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#AC9470"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.786,
  stopColor: "#CBB898"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "H",
  x1: 164.644,
  y1: 94.919,
  x2: 159.367,
  y2: 90.299,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#AC9470"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.786,
  stopColor: "#CBB898"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "I",
  x1: 169.867,
  y1: 94.919,
  x2: 164.628,
  y2: 90.539,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#AC9470"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.786,
  stopColor: "#CBB898"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "J",
  x1: 171.588,
  y1: 94.919,
  x2: 169.703,
  y2: 94.574,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#AC9470"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.786,
  stopColor: "#CBB898"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "K",
  x1: 177.558,
  y1: 94.995,
  x2: 172.119,
  y2: 90.141,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#AC9470"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.786,
  stopColor: "#CBB898"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "L",
  x1: 182.245,
  y1: 94.995,
  x2: 176.961,
  y2: 90.952,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#AC9470"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.786,
  stopColor: "#CBB898"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "M",
  x1: 123.608,
  y1: 8.436,
  x2: 117.57,
  y2: 5.919,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#AC9470"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.786,
  stopColor: "#CBB898"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "N",
  x1: 123.608,
  y1: 32.767,
  x2: 116.752,
  y2: 31.507,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#AC9470"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.786,
  stopColor: "#CBB898"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "O",
  x1: 101.763,
  y1: 11.659,
  x2: 94.259,
  y2: 6.61,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#AC9470"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.786,
  stopColor: "#CBB898"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "P",
  x1: 102.742,
  y1: 40.007,
  x2: 92.177,
  y2: 29.701,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#AC9470"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.786,
  stopColor: "#CBB898"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Q",
  x1: 153.165,
  y1: 40.007,
  x2: 142.601,
  y2: 29.701,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#AC9470"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.786,
  stopColor: "#CBB898"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "R",
  x1: 111.362,
  y1: 34.017,
  x2: 96.373,
  y2: 25.992,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#AC9470"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.786,
  stopColor: "#CBB898"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "S",
  x1: 148.346,
  y1: 11.659,
  x2: 140.841,
  y2: 6.611,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#AC9470"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.786,
  stopColor: "#CBB898"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "T",
  x1: 142.97,
  y1: 34.017,
  x2: 127.98,
  y2: 25.992,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#AC9470"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.786,
  stopColor: "#CBB898"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "U",
  x1: 135.433,
  y1: 63.141,
  x2: 118.352,
  y2: 46.311,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#AC9470"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.786,
  stopColor: "#CBB898"
})))));
export { SvgLogo as ReactComponent };
export default __webpack_public_path__ + "static/logo.c50d1db3.svg";